'use client';
import { useTypedTranslation } from '@/hooks/useTypedTranslation';
import Image from 'next/image';
import styles from './OptionsSection.module.css';

export default function OptionsSection() {
  const { t } = useTypedTranslation();

  return (
    <section className={styles.optionsSection}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <h2 className={styles.title}>{t('optionsSection.title')}</h2>
          <div className={styles.optionsContainer}>
            <div className={styles.option}>
              <div className={`${styles.number} ${styles.number1}`}>1</div>
              <div className={styles.text}>
                <h3>{t('optionsSection.shop.title')}</h3>
                <p>{t('optionsSection.shop.description')}</p>
              </div>
            </div>

            <div className={styles.option}>
              <div className={styles.number}>2</div>
              <div className={styles.text}>
                <h3>{t('optionsSection.validate.title')}</h3>
                <p>{t('optionsSection.validate.description')}</p>
              </div>
            </div>
          </div>

          {/* 
          <div className={styles.option}>
            <div className={styles.number}>3</div>
            <div className={styles.text}>
              <h3>{t('optionsSection.save.title')}</h3>
              <p>{t('optionsSection.save.description')}</p>
            </div>
          </div> */}
        </div>

        <div className={styles.imageContainer}>
          <Image
            src="/images/123_bg_traveler_desktop.webp"
            alt="Happy shopper with shopping bags"
            className={styles.image}
            width={2096}
            height={850}
            priority
            style={{ objectFit: 'cover', width: '120%', maxWidth: 'none', marginLeft: '-5%' }}
          />
        </div>
      </div>
    </section>
  );
}
